module.exports = __webpack_public_path__ + "c_static/img/1-8分享链接.cd461ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/1-8分享链接.jpg
// module id = 49T2
// module chunks = 33